import { render, staticRenderFns } from "./GroupWidgetWorkcenter.vue?vue&type=template&id=734583c7&"
import script from "./GroupWidgetWorkcenter.vue?vue&type=script&lang=js&"
export * from "./GroupWidgetWorkcenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports